import { bindKeymapWithCommand, findKeyMapForBrowser, isCapsLockOnAndModifyKeyboardEvent, redo, redoAlt, undo } from '@atlaskit/editor-common/keymaps';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { keydownHandler } from '@atlaskit/editor-prosemirror/keymap';
import { fg } from '@atlaskit/platform-feature-flags';
import { redoFromKeyboard, redoFromKeyboardWithAnalytics, undoFromKeyboard, undoFromKeyboardWithAnalytics } from './commands';
export function keymapPlugin(api) {
  var _api$analytics, _api$analytics3;
  var list = {};
  bindKeymapWithCommand(
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  findKeyMapForBrowser(redo), fg('platform_editor_controls_patch_analytics') ? redoFromKeyboardWithAnalytics(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions) : redoFromKeyboard, list);
  if (fg('platform_editor_cmd_y_mac_redo_shortcut')) {
    var _api$analytics2;
    bindKeymapWithCommand(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    findKeyMapForBrowser(redoAlt), fg('platform_editor_controls_patch_analytics') ? redoFromKeyboardWithAnalytics(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions) : redoFromKeyboard, list);
  }
  bindKeymapWithCommand(
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  undo.common, fg('platform_editor_controls_patch_analytics') ? undoFromKeyboardWithAnalytics(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions) : undoFromKeyboard, list);
  return new SafePlugin({
    props: {
      handleKeyDown: function handleKeyDown(view, event) {
        var keyboardEvent = isCapsLockOnAndModifyKeyboardEvent(event);
        return keydownHandler(list)(view, keyboardEvent);
      }
    }
  });
}